<template></template>

<script>
export default {
  props: {
    visualizationLayerTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      spotTimerId: null,
      thingTimerId: null,
      spotUpdateLayerTypes: ['eco2', 'sound', 'wind_speed'],
      thingUpdateLayerTypes: ['light', 'temperature', 'humidity'],
    };
  },
  computed: {
    currentFloorId: ({ $store }) => $store.state.current.floorId,
  },
  created() {
    this.updateTimerSetting();
  },
  beforeDestroy() {
    this.stopSpotUpdate();
    this.stopThingUpdate();
  },
  methods: {
    updateTimerSetting() {
      this.updateSpotTimerSetting();
      this.updateThingTimerSetting();
    },
    updateSpotTimerSetting() {
      const isSpotNeededToUpdate = this.visualizationLayerTypes.some(visualizationLayerType => this.spotUpdateLayerTypes.includes(visualizationLayerType));
      return isSpotNeededToUpdate ? this.startSpotUpdate(300000) : this.stopSpotUpdate();
    },
    updateThingTimerSetting() {
      const isThingNeededUpdate = this.visualizationLayerTypes.some(visualizationLayerType => this.thingUpdateLayerTypes.includes(visualizationLayerType));
      return isThingNeededUpdate ? this.startThingUpdate(300000) : this.stopThingUpdate();
    },
    startSpotUpdate(interval) {
      if (this.spotTimerId) return;
      this.spotTimerId = setInterval(() => {
        this.$store.dispatch('area/getFloorSpotsInBackground', this.currentFloorId);
      }, interval);
    },
    stopSpotUpdate() {
      if (!this.spotTimerId) return;
      clearInterval(this.spotTimerId);
      this.spotTimerId = null;
    },
    startThingUpdate(interval) {
      if (this.thingTimerId) return;
      this.thingTimerId = setInterval(() => {
        if (this.visualizationLayerTypes.includes('temperature')) {
          this.$store.dispatch('visualization/getSeasonalTemperatureSettingInBackground');
          this.$store.dispatch('visualization/getTemperatureThingsInBackground'); 
        }

        if (this.visualizationLayerTypes.includes('humidity')) {
          this.$store.dispatch('visualization/getHumidityThingsInBackground');
        }

        if (this.visualizationLayerTypes.includes('light')) {
          this.$store.dispatch('visualization/getLightThingsInBackground');
        }
      }, interval);
    },
    stopThingUpdate() {
      if (!this.thingTimerId) return;
      clearInterval(this.thingTimerId);
      this.thingTimerId = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// automatic_area_updater.vue?991464ec